import 'slick';
import $ from 'jquery';
import _ from 'lodash';

const CONFIG = {
    autoplaySpeed: 3000,
    pagination: true,
    displayCount: 3,
    tabletDisplayCount: 2,
    mobileDisplayCount: 1,
    centerMode: false,
    genericCarousel: false,
    prevArrow: '',
    nextArrow: '',
    variableWidth: false,
    responsiveVariableWidth: false
};
let elementCount = 1;
export class Carousel {

    constructor(element, config = {}) {
        this.$element = $(element);
        elementCount = this.$element[0].children.length;
        this.config = Object.assign({}, CONFIG, config);
        this.config.genericCarousel === true ? this.initGenericCarousel() : this.init();
    }

    init() {
        const selfInit = this;
        const { pagination, displayCount, tabletDisplayCount, mobileDisplayCount, centerMode, prevArrow, nextArrow, variableWidth, responsiveVariableWidth } = this.config;
        const showDots = (elementCount > 1 && this.config.pagination);
        const showArrows = (elementCount > 1);

        const sliderWithArrows = {
            dots: showDots,
            centerMode: centerMode,
            arrows: showArrows,
            speed: 200,
            slidesToShow: displayCount,
            slidesToScroll: displayCount,
            variableWidth: variableWidth,
            customPaging: function (slider, i) {
                return '<b>' + (i + 1) + '</b> <em>of</em> <b>' + Math.ceil(slider.slideCount / slider.options.slidesToScroll) + '</b>';
            },
            prevArrow: this.config.prevArrow,
            nextArrow: this.config.nextArrow,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: mobileDisplayCount,
                        slidesToScroll: mobileDisplayCount,
                        variableWidth: responsiveVariableWidth
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: tabletDisplayCount,
                        slidesToScroll: tabletDisplayCount,
                        variableWidth: responsiveVariableWidth
                    }
                }
            ]
        };

        const sliderWithoutArrows = {
            dots: showDots,
            centerMode: centerMode,
            arrows: showArrows,
            speed: 200,
            slidesToShow: displayCount,
            slidesToScroll: displayCount,
            customPaging: function (slider, i) {
                return '<b>' + (i + 1) + '</b> <em>of</em> <b>' + Math.ceil(slider.slideCount / slider.options.slidesToScroll) + '</b>';
            },
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: mobileDisplayCount,
                        slidesToScroll: mobileDisplayCount
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: tabletDisplayCount,
                        slidesToScroll: tabletDisplayCount
                    }
                }
            ]
        };

        this.$element.on('init', function() {
            selfInit.removeEmptyIds();
        });

        if (this.config.prevArrow !== '' && this.config.nextArrow !== '') {
            this.$element.slick(sliderWithArrows);
        } else {
            this.$element.slick(sliderWithoutArrows);
        }

        //Equal heights
        this.$element.on('setPosition', function(slick){
            var start = this;
            var height = 0;
            $('.ar-summary-card', start).height('auto');
            $('.slick-slide', start).each(function (key, element){
                if(height < $('.ar-summary-card', element).height()) {
                    height = $('.ar-summary-card', element).height();
                }
            });
            $('.ar-summary-card', start).height(height);
        });
    }

    initGenericCarousel() {
        const self = this;
        this.$element.slick({
            autoplay: true,
            fade: true,
            autoplaySpeed: this.config.autoplaySpeed,
            dots: true,
            nextArrow: $('.next-arrow'),
            prevArrow: '',
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1
        });

        this.$element.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            self.pageChange(nextSlide);
        });

        this.$element.on('setPosition', function(event, slick) {
            slick.$slides.css('height', slick.$slideTrack.height() + 'px');
            self.pageChange($('.carousel-element.slick-active').attr('data-slick-index'));
        });

        self.pageChange('0');
    }

    pageChange(slide) {
        const nextSlide =  $('[data-slick-index="'+slide+'"]');
        const insideSlide = $(nextSlide).find('.carousel-outer');
        const newSlideMidPosition = Math.floor((nextSlide.parent().height() - nextSlide.height()) / 2);
        $(insideSlide).css({'top': newSlideMidPosition + 'px'})
        const leftImagePosition = Math.floor(insideSlide.height() / 2);
        const leftImageItem = $(insideSlide).find('.left-image');
        $(leftImageItem).css({'top': leftImagePosition + 'px'});
        const nextSlideHeight = $(nextSlide.parent()).height();
        const heightOfDots = elementCount * 26 / 2;
        const dotsHeightNewPosition = Math.floor(nextSlideHeight / 2 - heightOfDots);
        $('.slick-dots').css({'top': dotsHeightNewPosition + 'px'});
    };

    removeEmptyIds() {
        $('.slick-slide', this.$element).each(function (key, element) {
            const id = $(element).attr('id');
            if (id === '') {
                $(element).removeAttr('id');
            }
        });
    };
}

export var render = function (element, config) {
    return new Carousel(element, config);
};